import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import inventoryService from "../services/inventoryService";
import Swal from "sweetalert2";

const initialState = {
    inventories: [],
    currentInventory: null,
    loading: false,
    error: null,
    totalElements: 0,
    totalPages: 0,
    pageNumber: 0,
    pageSize: 10,
};

const inventorySlice = createModule({
    name: "inventory",
    initialState,

    reducers: {
        setLoading: (state, payload) => { state.loading = payload; },
        setError: (state, payload) => { state.error = payload; },
        clearCurrentInventory: (state) => {
            state.currentInventory = null;
        },
        setInventories: (state, payload) => {
            console.log(payload)
            state.inventories = payload.content;
            state.totalElements = payload.totalElements;
            state.totalPages = payload.totalPages;
            state.pageNumber = payload.number;
            state.pageSize = payload.size;
        },

        setCurrentInventory: (state, payload) => {
            state.currentInventory = payload;
        },
        searchInventories: (state) => { state.loading = true; },
        getInventory: (state) => { state.loading = true; },
        createInventory: (state) => { state.loading = true; },
        updateInventory: (state) => { state.loading = true; },
        deleteInventory: (state) => { state.loading = true; },
        validateInventory: (state) => { state.loading = true; },
    },

    sagas: (A) => ({

        // 🔍 SEARCH
        *[A.searchInventories]({ payload }) {
            try {
                console.log(payload)
                yield put(A.setLoading(true));
                const res = yield call(inventoryService.search, payload);
                yield put(A.setInventories(res.data));
                yield put(A.setLoading(false));
            } catch (e) {
                yield put(A.setError(e.message));
                yield put(A.setLoading(false));
                payload.onError && payload.onError(e);
            }
        },

        // 📄 GET BY ID
        *[A.getInventory]({ payload }) {
            try {
                yield put(A.setLoading(true));
                const res = yield call(inventoryService.getById, payload);
                yield put(A.setCurrentInventory(res.data));
                yield put(A.setLoading(false));
            } catch (e) {
                yield put(A.setError(e.message));
                yield put(A.setLoading(false));
                payload.onError && payload.onError(e);
            }
        },

        // ➕ CREATE
        *[A.createInventory]({ payload }) {
            try {
                yield put(A.setLoading(true));
                yield call(inventoryService.create, payload.data);
                yield put(A.setLoading(false));

                Swal.fire({
                    icon: "success",
                    title: "Inventaire créé",
                    text: "L’inventaire a été enregistré avec succès.",
                    timer: 1800,
                    showConfirmButton: false
                });

                payload.onSuccess && payload.onSuccess();
            } catch (e) {
                yield put(A.setError(e.message));
                yield put(A.setLoading(false));
                payload.onError && payload.onError(e);
            }
        },

        // ✏️ UPDATE
        *[A.updateInventory]({ payload }) {
            try {
                yield put(A.setLoading(true));
                yield call(inventoryService.update, payload.id, payload.data);
                yield put(A.setLoading(false));

                Swal.fire({
                    icon: "success",
                    title: "Inventaire modifié",
                    text: "Les modifications ont été enregistrées.",
                    timer: 1800,
                    showConfirmButton: false
                });


                payload.onSuccess && payload.onSuccess();
            } catch (e) {
                yield put(A.setError(e.message));
                yield put(A.setLoading(false));
                payload.onError && payload.onError(e);
            }
        },

        // ❌ DELETE
        *[A.deleteInventory]({ payload }) {
            try {
                yield put(A.setLoading(true));
                yield call(inventoryService.delete, payload.id);
                yield put(A.setLoading(false));
                payload.onSuccess && payload.onSuccess();
            } catch (e) {
                yield put(A.setError(e.message));
                yield put(A.setLoading(false));
                payload.onError && payload.onError(e);
            }
        },

        // ✅ VALIDATE (this triggers stock adjustment on backend)
        *[A.validateInventory]({ payload }) {
            try {

                const confirm = yield call(() =>
                    Swal.fire({
                        title: "Valider l’inventaire ?",
                        text: "Le stock sera ajusté automatiquement selon les écarts.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Oui, valider",
                        cancelButtonText: "Annuler"
                    })
                );

                if (!confirm.isConfirmed) {
                    yield put(A.setLoading(false));
                    payload.onCancel && payload.onCancel();
                    return;
                }

                yield call(inventoryService.validate, payload.id);
                yield put(A.setLoading(false));

                yield call(() =>
                    Swal.fire({
                        icon: "success",
                        title: "Inventaire validé",
                        text: "Le stock a été ajusté avec succès.",
                        timer: 2000,
                        showConfirmButton: false
                    })
                );

                payload.onSuccess && payload.onSuccess();

            } catch (e) {
                yield put(A.setError(e.message));
                yield put(A.setLoading(false));
                payload.onError && payload.onError(e);
            }
        },
    }),
});

export default inventorySlice;
export const inventoryActions = inventorySlice.actions;
